import { render, staticRenderFns } from "./receiveWeight.vue?vue&type=template&id=3788f6a4&"
import script from "./receiveWeight.vue?vue&type=script&lang=js&"
export * from "./receiveWeight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports